import {Component, Prop, Vue} from "vue-property-decorator";
import Paginate from 'vuejs-paginate';

export type Pagination = {
  limit:number;
  offset:number;
}

@Component
export class PaginationComponent extends Vue {

  @Prop({type:Object, required:true}) value:Pagination;
  @Prop({type:Number, required:true}) total:number;

  get numPaginationPages() {
    return Math.ceil(this.total / this.value.limit);
  }

  emit(value){
    let output = { ...this.value, offset: value - 1 };
    this.$emit("input", output);
    this.$emit("change", output);
  }

  render() {
    if (this.numPaginationPages <= 1) return null;
    return (
      <div class="pagination-container">
        <Paginate
          value={this.value.offset + 1}
          pageCount={this.numPaginationPages}
          clickHandler={this.emit}
          containerClass="paginator"
          prevText="<"
          nextText=">"
        />
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-08cb2546/pagination.tsx" });